// removed by extract-text-webpack-plugin
module.exports = {"page":"wy0nYq3yfDm2R7Ou6rnzW"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/organizationPage.less
// module id = 629
// module chunks = 0